var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{class:_vm.classNames},[_c('font-awesome-icon',{staticStyle:{"margin-right":".5rem"},attrs:{"icon":_vm.icon}}),_c('u',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }